import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ProductOfferingFeatureCell } from '@mkp/shared/models';
import { ButtonSvgIcon } from '@mkp/shared/ui-library';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mkp-product-feature-cell',
  imports: [MatIconModule, TranslateModule],
  templateUrl: './product-feature-cell.component.html',
  styleUrl: './product-feature-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductFeatureCellComponent {
  @Input() feature!: ProductOfferingFeatureCell;

  readonly checkIconUrl = ButtonSvgIcon.Check;
  constructor() {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    iconRegistry.addSvgIcon('check', sanitizer.bypassSecurityTrustResourceUrl(this.checkIconUrl));
  }
}
